/* istanbul ignore file */
import React from 'react';

export type AuthorizationAuthValue = {
  isAuthenticated: boolean;
  backLinkLabel: string;
};
const AuthorizationAuthContext = React.createContext<AuthorizationAuthValue>({} as AuthorizationAuthValue);

export type AuthorizationAuthProviderProps = {
  isAuthenticated: boolean;
  backLinkLabel: string;
  children: React.ReactNode;
};

export const AuthorizationAuthProvider = ({
  isAuthenticated,
  backLinkLabel,
  children,
}: AuthorizationAuthProviderProps) => (
  <AuthorizationAuthContext.Provider value={{ isAuthenticated, backLinkLabel }}>
    {children}
  </AuthorizationAuthContext.Provider>
);

export const useAuthorizationAuth = () => React.useContext(AuthorizationAuthContext);
